module.exports = __webpack_public_path__ + "static/media/community.6fd74030.svg";